import {create} from 'zustand';
import {immer} from 'zustand/middleware/immer';
import {produce} from 'immer';
import {createSelectors} from '../lib/createStoreSelectors';

type ErrorStore = {
    error: string | null;
    setError: (error: string | null | Function) => void;
}

export const useErrorStoreBase = create<ErrorStore>()(
    immer(
        (set) => ({
            error: null,
            setError: (error: string | null | Function) => {
                set((state) => {state.error = typeof error === 'function' ? error(state.error) : error  })
            }
        })
    )
)

export const useErrorStore = createSelectors(useErrorStoreBase);
